/**
 * AudioStreamPlayer3D parser for the linter's property surface plus the inherited Node3D transform.
 * A missing value takes Godot's default, and a malformed number logs a warning and falls back to it.
 */
import { parseNode3D } from '../../base/node3d/parser';
import { boolOr, enumOr, floatOr, intOr } from '../../../parser/valueParsers';
import { parseAudioBase } from '../parseAudioBase';
import { AttenuationModel, DopplerTracking } from '../../../godot/scene/audio';
export function parseAudioStreamPlayer3D(heading, properties) {
    const baseProps = parseNode3D(heading, properties);
    return {
        ...baseProps,
        ...parseAudioBase(properties),
        attenuation_model: enumOr(properties.attenuation_model, AttenuationModel.INVERSE_DISTANCE, [
            AttenuationModel.INVERSE_DISTANCE,
            AttenuationModel.INVERSE_SQUARE_DISTANCE,
            AttenuationModel.LOGARITHMIC,
            AttenuationModel.DISABLED,
        ]),
        unit_size: floatOr(properties.unit_size, 10),
        max_distance: floatOr(properties.max_distance, 0),
        max_db: floatOr(properties.max_db, 3),
        attenuation_filter_cutoff_hz: floatOr(properties.attenuation_filter_cutoff_hz, 5000),
        attenuation_filter_db: floatOr(properties.attenuation_filter_db, -24),
        doppler_tracking: enumOr(properties.doppler_tracking, DopplerTracking.DISABLED, [
            DopplerTracking.DISABLED,
            DopplerTracking.IDLE_STEP,
            DopplerTracking.PHYSICS_STEP,
        ]),
        panning_strength: floatOr(properties.panning_strength, 1),
        area_mask: intOr(properties.area_mask, 1, 'AudioStreamPlayer3D.area_mask', 'uint32'),
        emission_angle_enabled: boolOr(properties.emission_angle_enabled, false),
        emission_angle_degrees: floatOr(properties.emission_angle_degrees, 45),
        emission_angle_filter_attenuation_db: floatOr(properties.emission_angle_filter_attenuation_db, -12),
    };
}
//# sourceMappingURL=parser.js.map